<template>
  <div>
    <div class="title_warp">
      <div class="hospital">{{ this.$store.getters.info.HospitalName }}</div>
      <div class="date" style="line-height: 30px; text-align: center">
        {{ currentDate }}
      </div>
      <div class="title">心理健康报告</div>
    </div>
    <div class="ScaleTitle">{{ ScaleTitle }}</div>
    <div class="tab-warp border-right">
      <table class="tab">
        <tbody>
          <tr>
            <td>
              {{ $store.getters.isCompany ? "测评编号" : "就诊号" }} ：{{
                userInfo.AdmNO
              }}
            </td>
            <td>姓名：{{ userInfo.Name }}</td>
            <td>性别：{{ userInfo.Gender }}</td>
            <td>年龄：{{ userInfo.Age }}</td>
          </tr>
          <tr>
            <td>科室名称：{{ userInfo.LocationName }}</td>
            <td v-if="!$store.getters.isCompany">床号：</td>
            <!-- <td colspan="2">诊断描述：{{ userInfo.Disease }}</td> -->
            <td colspan="2">测评时间：{{ finishTime }}</td>
          </tr>
          <tr>
            <td colspan="4">测评描述：{{ userInfo.Disease }}</td>
          </tr>
        </tbody>
      </table>
      <div class="contents">
          <div class="Title border-bottom">评估结果<span style="color:darkgrey;">(评估结果只反应测评者当前状况)</span></div>
        <el-row v-if="dataArr.length < 2" style="min-height: 350px">
          <el-col
            v-for="item in dataArr"
            :span="24 / dataArr.length"
            :key="item.id"
            style="position: relative"
          >
            <div
              class="canvas-warp"
              :id="item.id"
              :style="'width:100%;height:350px'"
            ></div>
          </el-col>
        </el-row>
        <div v-else class="canvas_warp">
          <div
            v-for="(item, index) in dataArr"
            :key="index"
            :id="(isDetaled ? 'dp' : 'kp') + index"
            :style="{
              width: item.isRow ? 100 + '%' : 50 + '%',
              height: 350 + 'px',
            }"
          >
            <div v-if="item.type">
              <div class="towLineTitle">{{ item.title }}</div>
              <div class="twoLineBox">
                <div v-for="(subItem, i) in item.twoLineArr" :key="i">
                  <div class="twoLine">
                    <div class="twoLineItem" style="width: 27%">
                      {{ subItem.name }}
                    </div>
                    <div class="twoLineItem">{{ subItem.activeAverage }}</div>
                    <div class="twoLineItem" style="width: 24%">
                      {{ subItem.socialAverage }}
                    </div>
                    <div class="twoLineItem" style="width: 24%">
                      {{ subItem.schoolAverage }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <el-row class="content-wrap">
            <el-col :span="24" class="Title border-bottom border-top"
              >评语</el-col
            >
            <div class="conclusion-list" v-html="ConclusionList"></div>
            <div class="edit-btn no-print">
              <el-button
                type="primary"
                @click="editConclusionClick('修改评语')"
                style="background: #091d7c"
                >修改评语</el-button
              >
            </div>
          </el-row>
          <el-row class="content-wrap">
            <el-col :span="24" class="Title border-bottom border-top"
              >建议</el-col
            >
            <div class="conclusion-list" v-html="SugList"></div>
            <div class="edit-btn no-print">
              <el-button
                type="primary"
                @click="editConclusionClick('修改建议')"
                style="background: #091d7c"
                >修改建议</el-button
              >
            </div>
          </el-row>
        </div>
      </div>
    </div>
    <div class="text-right">
      <div class="autograph">
        <div class="autograph_warp">
          <!-- 签名注销 -->
          <!-- <img
            v-if="userInfo.DoctorAutograph"
            width="100"
            :src="$store.getters.fileurl + userInfo.DoctorAutograph"
            alt=""
          />
          <span v-else>{{ userInfo.DoctorName }}</span> -->
          <span>
            {{ $store.getters.isCompany ? "心理咨询师" : "医生/护士" }} ：</span
          >
          <template v-if="IsOpenSysAutograph">
            <img
              v-if="userInfo.DoctorAutograph"
              width="100"
              :src="$store.getters.fileurl + userInfo.DoctorAutograph"
              alt=""
            />
            <span class="examine_name" v-else>{{ userInfo.DoctorName }}</span>
          </template>
          <!-- <img
            v-if="IsOpenSysAutograph"
            width="100"
            :src="$store.getters.fileurl + userInfo.DoctorAutograph"
            alt=""
          />         -->
          <span class="examine_name" v-else></span>
        </div>
        <div class="autograph_warp">
          <!-- <img
            v-if="userInfo.ExamineUserAutograph"
            width="100"
            :src="$store.getters.fileurl + userInfo.ExamineUserAutograph"
            alt=""
          />
          <span v-else>{{ userInfo.ExamineUserName }}</span> -->
          <span>审核人：</span>
          <template v-if="IsOpenExamineAutograph">
            <img
              v-if="userInfo.ExamineUserAutograph"
              width="100"
              :src="$store.getters.fileurl + userInfo.ExamineUserAutograph"
              alt=""
            />
            <span class="examine_name" v-else>{{
              userInfo.ExamineUserName
            }}</span>
          </template>
          <!-- <img
            v-if="IsOpenExamineAutograph"
            width="100"
            :src="$store.getters.fileurl + userInfo.ExamineUserAutograph"
            alt=""
          /> -->
          <span class="examine_name" v-else></span>
        </div>
      </div>
    </div>
    <!-- 插槽 -->
    <div class="slot_wrap">
      <!-- 保存按钮 -->
      <div class="save_btn" v-if="DataList">
        <el-button
          type="primary"
          @click="saveedit"
          v-if="!DataList.ClinicalReport || clinical == true"
          style="background: #091d7c"
          >保存为临床报告</el-button
        >
      </div>
      <!-- 审核打印按钮 -->
      <div class="slot_btn"><slot></slot></div>
    </div>
    <el-dialog
      append-to-body
      :title="dailogTitle"
      :close-on-click-modal="false"
      :visible.sync="conculusionDailog"
      width="850px"
    >
      <el-input
        class="textarea_warp"
        rows="18"
        type="textarea"
        v-model="editConclusion"
      >
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="conculusionDailog = false">取 消</el-button>
        <el-button type="primary" @click="submitConclusion()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import echarts from "echarts";
import westeros from "@/components/ECharts/theme/westeros";
import { Axios } from "@/common/request";
import moment from "moment";
export default {
  name: "detailReport",
  props: {
    admScaleID: {
      type: Number,
      default: 0,
    },
    clinical: {
      type: Boolean,
      default: false,
    },
    isShowbtn: {
      type: Boolean,
      default: false,
    },
    isDetaled: {
      type: Boolean,
      default: false,
    },
    isShow: {},
    ClinicalReportID: {
      type: Number,
    },
    doctorName: {
      type: String,
    },
  },
  data() {
    return {
      nowDate: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      currentDate: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      editConclusion: "",
      dailogTitle: "修改评语",
      conculusionDailog: false,
      sugisonDailog: false,
      IsOpenSysAutograph: null,
      IsOpenExamineAutograph: null,
      DataList: null,
      userInfo: {},
      finishTime: null, //测评时间
      HospitalName: "",
      tableData: [
        {
          col1: "就诊号：",
          col2: "姓名：",
          col3: "年龄：",
          col4: "性别：",
        },
        {
          col1: "护理单元：",
          col2: "床号：",
          col3: "诊断描述：",
          col4: "",
        },
      ],
      BaseConclusionList: "",
      BaseSugList: "",
      SugList: "",
      ConclusionList: "",
      ScaleTitle: "",
      dataArr: [],
      CurrentHeight: 0,
      chart: null,
      datas: {
        id: "",
        type: "",
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [],
        },
        legend: {
          data: [],
        },
        series: {
          data: [],
          type: "",
        },
        title: {
          text: "",
        },
        yAxis: {
          type: "value",
        },
        tooltip: {
          trigger: "axis",
        },
        /*   toolbox: {
					    feature: {
					      saveAsImage: {}
					    }
					  } */
      },
      ImageType: [
        {
          ID: 0,
          type: "none",
        },
        {
          ID: 1,
          type: "bar",
        },
        {
          ID: 2,
          type: "gauge",
        },
        {
          ID: 3,
          type: "radar",
        },
        {
          ID: 4,
          type: "seesaw",
        },
        {
          ID: 5,
          type: "pie",
        },
        {
          ID: 6,
          type: "rainbow",
        },
        {
          ID: 7,
          type: "line",
        },
        {
          ID: 8,
          type: "scatter",
        },
        {
          ID: 9,
          type: "twoLine",
        },
      ],
      examine: "",
      ConclusionListVIew: "",
    };
  },
  mounted() {
    // 获取医院名称
    this.HospitalName = this.$store.getters.info.HospitalName;
  },
  methods: {
    // 修改评论/建议
    editConclusionClick(title) {
      if (title == "修改评语") {
        this.editConclusion = this.ConclusionList.replace(/<br>/g, "\n");
      } else {
        this.editConclusion = this.SugList.replace(/<br>/g, "\n");
      }
      this.dailogTitle = title;
      this.conculusionDailog = true;
    },
    // 提交修改的评语及建议
    submitConclusion() {
      if (this.dailogTitle == "修改评语") {
        this.ConclusionList = this.editConclusion.replace(/\n/g, "<br>");
      } else {
        this.SugList = this.editConclusion.replace(/\n/g, "<br>");
      }
      this.conculusionDailog = false;
    },
    //提交修改后的报告
    saveedit() {
      //都没有修改

      if (
        this.BaseSugList == this.SugList &&
        this.BaseConclusionList == this.ConclusionList
      ) {
        this.$message({
          message: "未作出修改",
          type: "warning",
        });
        return;
      }

      if (
        this.BaseSugList !== this.SugList ||
        this.BaseConclusionList !== this.ConclusionList
      ) {
        Axios("Alarm/InserOrUpdateClinical", "post", {
          ClinicalReportID: this.ClinicalReportID,
          AdmScaleID: this.admScaleID,
          ClinicalConclusion: this.ConclusionList,
          ClinicalSuggestion: this.SugList,
        }).then((res) => {
          if (res.Status == 1) {
            this.$message({
              message: "保存成功",
              type: "success",
            });
            this.$emit("changereport", "");
          }
        });
      }
    },
    spanCol({ row, rowIndex, column, columnIndex, data }) {
      if (rowIndex % 2 === 0) {
        if (columnIndex === 2) {
          return {
            rowspan: 1,
            colspan: 2,
          };
        } else if (columnIndex === 3) {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    findType(id) {
      return this.ImageType.find((m) => m.ID == id).type;
    },
    initChart(options) {
      if (options) {
        this.chart = echarts.init(
          document.getElementById(options.id),
          "westeros"
        );
        // 象限图便宜坐标
        if (options.itemType == 8) {
          options.xAxis.offset = -(this.chart.getHeight() - 16) / 2; // 横坐标偏移
          options.yAxis.offset = -(this.chart.getWidth() - 24) / 2; // 纵坐标偏移
        }
        this.chart.setOption(options);
      }
    },
    radar(data) {},
    line(data) {},
    initData(e) {
      var that = this;
      if (e == "examine") {
        that.dataArr = [];
      }
      Axios(
        "Business/GetAdmScaleReport",
        "get",
        {
          admScaleID: that.admScaleID,
        },
        that
      ).then((ret) => {
        that.IsOpenSysAutograph = ret.Data.patientInfo.IsOpenSysAutograph;
        that.IsOpenExamineAutograph =
          ret.Data.patientInfo.IsOpenExamineAutograph;
        that.DataList = ret.Data;
        var tempdata = ret.Data;
        this.$emit("reportData", tempdata); // 报告数据传到父组件
        this.examine = tempdata.patientInfo.ExamineUserName;
        this.finishTime = moment(tempdata.patientInfo.FinishTime).format(
          "YYYY-MM-DD"
        );
        // 量表标题
        that.userInfo = tempdata.patientInfo;

        // this.userInfo = tempdata.patientInfo;
        this.ScaleTitle = "测试量表：" + tempdata.scaInfo.Title;
        that.tableData[0]["col1"] =
          that.tableData[0]["col1"] + tempdata.patientInfo.AdmNO;
        that.tableData[0]["col2"] =
          that.tableData[0]["col2"] + tempdata.patientInfo.Name;
        that.tableData[0]["col3"] =
          that.tableData[0]["col3"] + tempdata.patientInfo.Age;
        that.tableData[0]["col4"] =
          that.tableData[0]["col4"] + tempdata.patientInfo.Gender;
        that.tableData[1]["col3"] =
          that.tableData[1]["col3"] +
          (!tempdata.patientInfo.Disease ? "" : tempdata.patientInfo.Disease);
        /* 判断报告类型 是否为临床报告*/
        if (this.clinical) {
          this.SugList = ret.Data.ClinicalReport.ClinicalSuggestion;
          this.ConclusionList = ret.Data.ClinicalReport.ClinicalConclusion;
          //
          this.BaseSugList = this.SugList;
          this.BaseConclusionList = this.ConclusionList;
        } else {
          let SugListData = tempdata.sugList;
          let SugList = [];
          let lastConclusion = []; // 总分评论结果放到最后
          let ConclusionList = [];
          if (SugListData && SugListData.length > 0) {
            SugListData.forEach((item,index) => {
              // 建议
              if (item.Suggestion && SugList.indexOf(item.Suggestion) == -1) {
                SugList.push(item.Suggestion);
              }

              // 评语
              if (
                item.Conclusion &&
                ConclusionList.indexOf(item.Conclusion) == -1
              ) {
                // ConclusionList.push(item.Conclusion);
                if (item.Conclusion.indexOf("您的总分为") == -1) {
                  ConclusionList.push(item.Conclusion);
                } else {
                  lastConclusion.push(item.Conclusion);
                }
              }else{
                console.log('重复了：'+JSON.stringify(item)+"---"+index);
              }
            });
          }
          this.SugList = "";
          this.BaseSugList = "";
          if (SugList && SugList.length > 0) {
            SugList.forEach((item, index) => {
              if (item != " " && item != "") {
                if (index == SugList.length - 1) {
                  if (SugList.length == 1) {
                    this.SugList = this.SugList + item;
                    this.BaseSugList = this.BaseSugList + item;
                  } else {
                    this.SugList = this.SugList + (index + 1) + "、" + item;
                    this.BaseSugList =
                      this.BaseSugList + (index + 1) + "、" + item;
                  }
                } else {
                  this.SugList =
                    this.SugList + (index + 1) + "、" + item + "<br>";
                  this.BaseSugList =
                    this.BaseSugList + (index + 1) + "、" + item + "<br>";
                }
              }
            });
          }
          this.ConclusionList = "";
          ConclusionList = ConclusionList.concat(lastConclusion);
          if (ConclusionList && ConclusionList.length > 0) {
            ConclusionList.forEach((item, index) => {
              if (item != " " && item != "") {
                if (index == ConclusionList.length - 1) {
                  if (ConclusionList.length == 1) {
                    this.ConclusionList = this.ConclusionList + item;
                    this.BaseConclusionList = this.BaseConclusionList + item;
                  } else {
                    this.ConclusionList =
                      this.ConclusionList + (index + 1) + "、" + item;
                    this.BaseConclusionList =
                      this.BaseConclusionList + (index + 1) + "、" + item;
                  }
                } else {
                  this.ConclusionList =
                    this.ConclusionList + (index + 1) + "、" + item + "<br>";
                  this.BaseConclusionList =
                    this.BaseConclusionList +
                    (index + 1) +
                    "、" +
                    item +
                    "<br>";
                }
              }
            });
          }
        }
        var specialData = tempdata.charts.filter((m) => m.ChartType == 6);
        if (tempdata.charts && tempdata.charts.length > 0) {
          // 记录是否有类型为8 的量表
          let isChartType = tempdata.charts.find((item) => item.ChartType == 8);
          var index = 0;
          tempdata.charts.forEach((item) => {
            var type = that.findType(item.ChartType);
            if (item.Index && item.Index.length > 0) {
              var result = {};
              switch (type) {
                case "bar":
                  result = that.convertbarData(item, index, tempdata);
                  break;
                case "line":
                  result = that.convertlineData(item, index, tempdata);
                  break;
                case "gauge":
                  result = that.convertgaugeData(item, index, tempdata);
                  break;
                case "radar":
                  result = that.convertradarData(item, index, tempdata);
                  break;
                case "seesaw":
                  result = that.convertSeeSawData(item, index, tempdata);
                  break;
                case "pie":
                  result = that.convertPieData(item, index, tempdata);
                  break;
                case "twoLine":
                  result = that.convertTowLine(item, index, tempdata);
                  break;

                case "scatter":
                  result = that.convertScatter(
                    item,
                    index,
                    tempdata,
                    item.ChartType
                  );
                  break;
                case "rainbow":
                  result = that.convertRainbowData(item, index, tempdata);
                  break;
                case "none":
                  result = 0;
                  break;
                default:
                  break;
              }
              index++;
              // 量表类型为8 的单独占一行
              if (isChartType) {
                result.isRow = true;
              }

              that.dataArr.push(result);
              console.log(that.dataArr);
              // 二线图
              if (!result.type) {
                this.$nextTick(() => {
                  setTimeout(() => {
                    //  执行echarts方法
                    that.initChart(result);
                  }, 100);
                });
              }
            }
          });
        }
      });
    },
    // 象限图(艾森克人格问卷（ＥＰＱ）（儿童7-15岁）)
    convertScatter(data, index, tempdata, type) {
      var RangeDescribe = JSON.parse(data.RangeDescribe);
      let arr = data.Index;
      let markLine = RangeDescribe.series.markLine;
      let xName = RangeDescribe.series.extraconfig.X;
      let yName = RangeDescribe.series.extraconfig.Y;

      let xMin = 0;
      let xMax = 100; // 初始化100
      let yMin = 0;
      let yMax = 100;
      let coordinates = []; //圆点位置
      let markAreaArr = RangeDescribe.series.markArea.data; // 四个象限名字和位置
      let markAreaData = []; //马氏线配置项
      //   组装象限名字和坐标
      if (markAreaArr && markAreaArr.length > 0) {
        markAreaArr.forEach((item) => {
          let markAreaDataInner = [];
          let markAreaObj = {
            name: item[0].name,
            coord: item[0].coord,
          };
          let obj = {
            coord: item[0].coord,
          };
          markAreaDataInner.push(markAreaObj);
          markAreaDataInner.push(obj);
          markAreaData.push(markAreaDataInner);
        });
      }
      //   圆点坐标
      if (arr && arr.length > 0) {
        arr.forEach((item) => {
          if (item.CaculationName == xName) {
            xMin = item.Min;
            xMax = item.Max;
          }
          if (item.CaculationName == yName) {
            yMin = item.Min;
            yMax = item.Max;
          }
          coordinates.push(item.Score);
        });
      }
      let o_data = [
        {
          type: "scatter",
          data: [coordinates],
          symbolSize: 10,
          markLine: markLine,
          markArea: {
            silent: true,
            data: markAreaData,
          },
        },
      ];
      let id = (this.isDetaled ? "dp" : "kp") + index;
      let oDem = document.getElementById(id);
      let options = {
        id: (this.isDetaled ? "dp" : "kp") + index,
        itemType: type,
        title: {
          text: RangeDescribe.option.title.text,
          textStyle: {
            fontSize: 12,
          },
          bottom: 50,
          left: 354, // n量表
        },
        tooltip: {
          trigger: "item",
          axisPointer: {
            show: true,
            type: "cross",
            lineStyle: {
              type: "dashed",
              width: 1,
            },
          },
        },
        grid: {
          top: "8px",
          right: "12px",
          left: "12px",
          bottom: "8px",
          show: true,
          borderColor: "#666",
          backgroundColor: "#ffffff",
        },
        xAxis: {
          name: RangeDescribe.xAxis.name,
          type: "value",
          scale: true,
          max: xMax,
          min: xMin,
          offset: 0,
          splitLine: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: "#000",
              fontWeight: 600,
            },
          },
          axisTick: {
            inside: true,
          },
          nameTextStyle: {
            verticalAlign: "bottom",
            padding: [0, 0, 0, -80],
            fontSize: 12,
          },
        },
        yAxis: {
          name: "",
          type: "value",
          scale: true,
          max: yMax,
          offset: 0,
          min: yMin,
          axisTick: {
            inside: false,
          },
          splitLine: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: "#666",
            },
          },
        },
        series: o_data,
      };
      return options;
    },
    // 柱状图
    convertbarData(data, index, tempdata) {
      var dataAxis = [];
      var tempData = [];
      var max = 0,
        min = 0;

      data.Index.forEach((item) => {
        dataAxis.push(item.CaculationName);
        let itemMax = item.Score > item.Max ? item.Score : item.Max;
        tempData.push(item.Score);
        if (max < itemMax) {
          max = itemMax;
        }
        if (min > item.Min) {
          min = item.Min;
        }
      });
      let markLine = {};
      let itemStyle = {};
      var barcolor = "";
      let Fn = "";
      // 判断是否有额外配置参数
      if (data.RangeDescribe) {
        var RangeDescribe = JSON.parse(data.RangeDescribe);
        markLine = RangeDescribe.markLine;
        itemStyle = RangeDescribe.itemStyle;
        if (RangeDescribe.color) barcolor = RangeDescribe.color;
        if (
          RangeDescribe.itemStyle &&
          RangeDescribe.itemStyle.normal &&
          RangeDescribe.itemStyle.normal.color
        ) {
          Fn = RangeDescribe.itemStyle.normal.color;
        }
      }
      let right = " 8%";

      let le = "";
      if (
        markLine &&
        markLine.data &&
        markLine.data.length > 0 &&
        markLine.data[0] &&
        markLine.data[0].length > 0 &&
        markLine.data[0][0]
      ) {
        le = markLine.data[0][0].name && markLine.data[0][0].name.length;
      }
      // 判断马氏线文字是否过长
      if (le && le > 4) {
        right = "14%";
      }
      let options = {
        id: (this.isDetaled ? "dp" : "kp") + index,
        grid: {
          left: "5%",
          right: right,
          top: "5%",
          bottom: "5%",
          containLabel: true,
        },
        xAxis: {
          data: dataAxis,
          // type: "category",
          axisLabel: {
            inside: false,
            interval: 0,
            rotate: 30,
            textStyle: {
              color: "#a0a0f0",
            },
          },
          z: 10,
        },
        yAxis: {
          type: "value",
          max: max,
          min: min,
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: "#999",
            },
          },
        },
        dataZoom: [
          {
            type: "inside",
          },
        ],
        series: [],
      };

      options.series.push({
        type: "bar",
        name: data.Title,
        label: {
          show: true,
        },
        itemStyle: {
          normal: {
            color: function (params) {
              return eval(Fn);
            },
          },
        },
        color: barcolor,
        data: tempData,
        markLine: markLine,
      });
      return options;
    },
    // 仪表盘
    convertgaugeData(data, index, tempdata) {
      let between;
      if (data.RangeDescribe) {
        between = JSON.parse(data.RangeDescribe);
      }
      var max = 0,
        min = 0;
      var detail = {};
      if (between) {
        if (between.color && between.color.length > 0) {
          between.color.forEach((item) => {
            if (item.max >= max) {
              max = item.max;
            }
            if (item.min <= min) {
              min = item.min;
            }
          });
        }
        if (between.detail) {
          detail = between.detail;
        }
      }
      let options = {
        id: (this.isDetaled ? "dp" : "kp") + index,
        tooltip: {
          formatter: "{a} <br/>{b} : {c}分",
        },
        title: {
          text: tempdata.charts[index].Title
            ? tempdata.charts[index].Title
            : "总分",
          bottom: "20%",
          left: "center",
        },
        series: [],
      };
      var tempData = [];
      data.Index.forEach((item1) => {
        tempData.push({
          value: item1.Score,
          // name: "总分",
        });
      });
      let colorArea = this.getColorArea(data.RangeDescribe);
      options.series.push({
        type: "gauge",
        name: data.Title,
        axisLine: {
          lineStyle: {
            color: colorArea,
          },
        },
        detail: detail,
        min: min,
        max: max,
        data: tempData,
      });
      return options;
    },
    // 折线图
    convertlineData(data, index, tempdata) {
      var dataAxis = [];
      var markline = "";
      var tempData = [];
      var yAxisConfig = {
        max: 0,
        min: 0,
        type: "value",
        data: [],
      };
      var max = 0,
        min = 0;
      data.Index.forEach((item) => {
        dataAxis.push(item.CaculationName);
        tempData.push(item.Score);
        if (max < item.Max) {
          max = item.Max;
        }
        if (min > item.Min) {
          min = item.Min;
        }
      });

      if (data.RangeDescribe) {
        var RangeDescribe = JSON.parse(data.RangeDescribe);
        markline = RangeDescribe.markLine;
        //设置max min 在轮询设置max之后,再绑定max的值
        if (RangeDescribe.yAxis) {
          if (RangeDescribe.yAxis.max != 0) {
            max = RangeDescribe.yAxis.max;
          }
          if (RangeDescribe.yAxis.min != 0) {
            min = RangeDescribe.yAxis.min;
          }
          if (RangeDescribe.yAxis.type) {
            if (RangeDescribe.yAxis.type == "category") {
              yAxisConfig.type = RangeDescribe.yAxis.type;
              yAxisConfig.data = dataAxis;
              dataAxis = null;
            }
          }
        }
      }
      let options = {
        id: (this.isDetaled ? "dp" : "kp") + index,
        grid: {
          left: "6%",
          right: "5%",
          top: "6%",
          containLabel: true,
        },
        title: {
          text: data.Title ? data.Title : "",
          subtext: "",
          left: "center",
          textStyle: {
            color: "#464646",
            fontWeight: 500,
          },
        },

        xAxis: {
          data: dataAxis,
          axisLabel: {
            inside: false,
            interval: 0,
            rotate: 30,
            textStyle: {
              //color: "#091d7c",
              color: "#000000",
            },
            fontWeight: 400,
            fontFamily: "Microsoft YaHei",
            max: max,
            min: min,
          },

          z: 10,
          // splitLine:{
          //   show:false  去除虚线
          // }
        },
        yAxis: {
          type: yAxisConfig.type,
          data: yAxisConfig.data,
          max: max,
          min: min,
          axisLine: {
            show: false,
          },
          axisTick: {
            interval: 0,
            show: false,
          },
          axisLabel: {
            interval: 0,
            textStyle: {
              color: "#999",
            },
          },
          splitLine: {
            show: false,
          },
        },
        dataZoom: [
          {
            type: "inside",
          },
        ],
        series: [],
      };
      options.series.push({
        type: "line",
        name: data.title,
        label: {
          show: true,
        },
        data: tempData,
        markLine: markline,
      });

      return options;
    },
    // 折线图 (旧版)
    OldconvertlinesData(data, index, tempdata) {
      var dataAxis = [];
      var markline = "";
      var tempData = [];
      var max = 0,
        min = 0;
      data.Index.forEach((item) => {
        dataAxis.push(item.CaculationName);
        tempData.push(item.Score);
        if (max < item.Max) {
          max = item.Max;
        }
        if (min > item.Min) {
          min = item.Min;
        }
      });

      if (data.RangeDescribe) {
        var RangeDescribe = JSON.parse(data.RangeDescribe);
        markline = RangeDescribe.markLine;
        //设置max min 在轮询设置max之后,再绑定max的值
        if (RangeDescribe.yAxis && RangeDescribe.yAxis.max != 0) {
          max = RangeDescribe.yAxis.max;
        } else if (RangeDescribe.max != 0) {
          max = RangeDescribe.max;
        }
      }
      let options = {
        id: (this.isDetaled ? "dp" : "kp") + index,
        xAxis: {
          data: dataAxis,
          axisLabel: {
            inside: false,
            interval: 0,
            rotate: 30,
            textStyle: {
              color: "#a0a0f0",
            },
          },
          z: 10,
        },
        yAxis: {
          type: "value",
          max: max,
          min: min,
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: "#999",
            },
          },
        },
        dataZoom: [
          {
            type: "inside",
          },
        ],
        series: [],
      };
      options.series.push({
        type: "line",
        name: data.Title,
        label: {
          show: true,
        },
        data: tempData,
        markLine: markline,
      });
      return options;
    },
    //跷跷板图形
    convertSeeSawData(data, index, tempdata) {
      var datascore = data.Index.filter((m) => m.CaculationName != "总分");
      var factor = {
        left: datascore[0],
        right: datascore[1],
      };
      var point = {
        left: 1650,
        right: 1650,
      };
      var Bracket = {
        left: 550,
        right: 550,
      };
      if (factor.left.Score > factor.right.Score) {
        point.left = point.left - 1100;
        point.right = point.right + 1100;
        Bracket.left = Bracket.left - 550;
        Bracket.right = Bracket.right + 550;
      } else if (factor.left.Score < factor.right.Score) {
        point.right = point.right - 1100;
        point.left = point.left + 1100;
        Bracket.left = Bracket.left + 550;
        Bracket.right = Bracket.right - 550;
      }

      var markLineOpt = {
        animation: true,
        lineStyle: {
          type: "solid",
          width: 5,
        },

        data: [
          [
            {
              coord: [0, Bracket.left],
              symbol: "none",
            },
            {
              coord: [1100, Bracket.right],
              symbol: "none",
            },
          ],
        ],
      };
      var options = {
        id: (this.isDetaled ? "dp" : "kp") + index,
        title: {
          text: tempdata.scaInfo.Title,
          textStyle: {
            fontSize: 14,
            fontWeight: 500,
          },
        },
        grid: {
          left: "25%",
          top: "10%",
          containLabel: true,
        },
        legend: {
          emphasis: {
            rich: {
              b: {
                height: 40,
              },
            },
          },
        },
        tooltip: {
          //formatter: " {a}:<br />" + "分数: ({c})"
          formatter: function (a, b) {
            return a.seriesName + ":<br />" + "分数:" + a.data.score;
          },
        },
        xAxis: [
          {
            gridIndex: 0,
            min: 0,
            max: 1800,
            show: false,
          },
        ],
        yAxis: [
          {
            gridIndex: 0,
            min: 0,
            max: 1800,
            show: false,
          },
        ],
        series: [
          {
            name: "跷跷板",
            type: "scatter",
            xAxisIndex: 0,
            yAxisIndex: 0,
            markLine: markLineOpt,
          },
          {
            name: "支架",
            type: "pictorialBar",
            symbolSize: ["40", "40"],

            symbol: "triangle",
            itemStyle: {
              emphasis: {
                opacity: 1,
              },
            },
            data: [
              {
                value: [
                  (point.left + point.right) / 6,
                  ((point.left + point.right) / 6) * 2,
                ],
                symbolPosition: "center",
                score: "",
              },
            ],
            z: 12,
          },
          {
            name: factor.left.CaculationName,
            type: "pictorialBar",
            symbolSize: ["80", "80"],
            itemStyle: {
              color: {
                type: "radial",
                x: 0.5,
                y: 0.5,
                r: 0.5,
                colorStops: [
                  {
                    offset: 0,
                    color: "#B452CD", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#FFD700", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
            symbol: "circle",

            data: [
              {
                value: [0, point.left],
                symbolPosition: "center",
                score: factor.left.Score,
              },
            ],
            z: 12,
          },
          {
            name: factor.right.CaculationName,
            type: "pictorialBar",
            symbolSize: ["80", "80"],
            itemStyle: {
              color: {
                type: "radial",
                x: 0.5,
                y: 0.5,
                r: 0.5,
                colorStops: [
                  {
                    offset: 0,
                    color: "#B452CD", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#87CEFA", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
            symbol: "circle",

            data: [
              {
                value: [1100, point.right],
                symbolPosition: "center",
                score: factor.right.Score,
              },
            ],
            z: 12,
          },
        ],
      };
      return options;
    },
    // 二线图
    convertTowLine(data, index, tempdata) {
      let currentData = data.Index;
      let result = {};
      let twoLineArr = JSON.parse(data.RangeDescribe);
      if (twoLineArr && twoLineArr.length) {
        let scoreObj = {
          name: "得分",
        };
        let currentAgeData = twoLineArr.find((item) => {
          return (
            this.userInfo.Age >= item.minAge && this.userInfo.Age <= item.maxAge
          );
        });
        if (
          currentAgeData &&
          currentAgeData.twoLineRules &&
          currentAgeData.twoLineRules.length
        ) {
          currentData.forEach((item) => {
            if (item.CaculationName.indexOf("活动情况") != -1) {
              scoreObj.activeAverage = item.Score;
            } else if (item.CaculationName.indexOf("社交情况") != -1) {
              scoreObj.socialAverage = item.Score;
            } else if (item.CaculationName.indexOf("学校情况") != -1) {
              scoreObj.schoolAverage = item.Score;
            }
          });
        }
        currentAgeData.twoLineRules.push(scoreObj);
        result = {
          id: (this.isDetaled ? "dp" : "kp") + index,
          twoLineArr: currentAgeData.twoLineRules,
          title: currentAgeData.title,
          type: "twoLine",
        };
      }
      return result;
    },
    //饼状图（暂无对应量表）
    convertPieData(data, index, tempdata) {},
    //雷达图
    convertradarData(data, index, tempdata) {
      // var between = JSON.parse(data.RangeDescribe);
      var between = data.Index;
      var max = 0,
        min = 0;
      if (between && between.length > 0) {
        between.forEach((item) => {
          if (item.max >= max) {
            max = item.max;
          }
          if (item.min <= min) {
            min = item.min;
          }
        });
      }
      let options = {
        id: (this.isDetaled ? "dp" : "kp") + index,
        title: {
          text: data.Title,
          textStyle: {
            fontSize: 14,
            fontWeight: 500,
          },
          // subtext: data.Title,
        },
        tooltip: {},
        series: [],
      };
      var tempData = [];
      var indicator = [];
      data.Index.forEach((item1) => {
        var max = 0,
          min = 0;
        if (max < item1.Max) {
          max = item1.Max;
        }
        if (min > item1.Min) {
          min = item1.Min;
        }
        indicator.push({
          min: min,
          max: max,
          name: item1.CaculationName,
        });
        tempData.push(item1.Score);
      });
      options.radar = {
        indicator: indicator,
        radius: 100, // 控制图形显示大小
        name: {
          textStyle: {
            color: "#fff",
            backgroundColor: "#999",
            borderRadius: 3,
            padding: [3, 5],
          },
        },
      };
      options.series.push({
        type: "radar",
        name: tempdata.scaInfo.Title,
        label: {
          show: true,
          position: "insideBottom",
        },
        data: [
          {
            value: tempData,
            name: data.Title,
            label: {
              show: true,
              position: "insideBottom",
            },
          },
        ],
      });
      return options;
    },
    //彩虹图   （幸福感指数)
    convertRainbowData(data, index, tempdata) {
      var max = 0,
        min = 0,
        score = 0;
      var dataAxis = [];
      var tempData = [];
      var totalScore = 0;
      data.Index.forEach((item) => {
        dataAxis.push(item.CaculationName);
        tempData.push(item.Score);
        score = item.Score;
        totalScore = item.Score;
        if (max < item.Max) {
          max = item.Max;
        }
        if (min > item.Min) {
          min = item.Min;
        }
      });
      var average = max / 7;
      let options = {
        id: (this.isDetaled ? "dp" : "kp") + index,
        title: {
          text: dataAxis[0] + "：" + totalScore + "",
          left: 18,
          top: "8%",
          textStyle: {
            fontSize: 14,
            fontWeight: 500,
          },
        },
        visualMap: {
          top: "16%",
          left: 18,
          pieces: [
            {
              gt: min,
              lte: average * 1,
              label: "紫【" + min + "-" + average * 1 + "分】",
              color: "#8B00FF",
            },
            {
              gt: average * 1,
              lte: average * 2,
              label: "蓝【" + average + "-" + average * 2 + "分】",
              color: "#0000FF",
            },
            {
              gt: average * 2,
              lte: average * 3,
              label: "青【" + average * 2 + "-" + average * 3 + "分】",
              color: "#00FFFF",
            },
            {
              gt: average * 3,
              lte: average * 4,
              label: "绿【" + average * 3 + "-" + average * 4 + "分】",
              color: "#00FF00",
            },
            {
              gt: average * 4,
              lte: average * 5,
              label: "黄【" + average * 4 + "-" + average * 5 + "分】",
              color: "#FFFF00",
            },
            {
              gt: average * 5,
              lte: average * 6,
              label: "橙【" + average * 5 + "-" + average * 6 + "分】",
              color: "#FF7F00",
            },
            {
              gt: average * 6,
              lte: average * 7,
              label: "红【" + average * 6 + "-" + max + "分】",
              color: "#FF0000",
            },
          ],
          outOfRange: {
            color: "#999",
          },
        },
        series: [
          {
            name: "红",
            type: "gauge",
            radius: "100%",
            startAngle: 180,
            endAngle: 0,
            splitNumber: 0, //刻度数量
            center: ["50%", "65%"],
            axisLine: {
              lineStyle: {
                width: 20,
                shadowBlur: 0,
                color: [[1, "#FF0000 "]],
              },
            },
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            detail: {
              show: false,
            },
            pointer: {
              show: false,
              length: "100%",
              width: 3,
              title: {
                show: false,
              },
            },
          },

          {
            name: "橙",
            type: "gauge",
            radius: "90%",
            startAngle: 180,
            endAngle: 0,
            splitNumber: 0, //刻度数量
            center: ["50%", "65%"],
            axisLine: {
              lineStyle: {
                width: 20,
                shadowBlur: 0,
                color: [[1, "#FF7F00"]],
              },
            },
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            detail: {
              show: false,
            },
          },
          {
            name: "黄",
            type: "gauge",
            radius: "80%",
            startAngle: 180,
            endAngle: 0,
            splitNumber: 0, //刻度数量
            center: ["50%", "65%"],
            axisLine: {
              lineStyle: {
                width: 20,
                shadowBlur: 0,
                color: [[1, "#FFFF00"]],
              },
            },
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            detail: {
              show: false,
            },
          },
          {
            name: "绿",
            type: "gauge",
            radius: "70%",
            startAngle: 180,
            endAngle: 0,
            splitNumber: 0, //刻度数量
            center: ["50%", "65%"],
            axisLine: {
              lineStyle: {
                width: 20,
                shadowBlur: 0,
                color: [[1, "#00FF00"]],
              },
            },
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            detail: {
              show: false,
            },
          },
          {
            name: "青",
            type: "gauge",
            radius: "60%",
            startAngle: 180,
            endAngle: 0,
            splitNumber: 0, //刻度数量
            center: ["50%", "65%"],
            axisLine: {
              lineStyle: {
                width: 20,
                shadowBlur: 0,
                color: [[1, "#00FFFF"]],
              },
            },
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            detail: {
              show: false,
            },
          },
          {
            name: "蓝",
            type: "gauge",
            radius: "50%",
            startAngle: 180,
            endAngle: 0,
            splitNumber: 0, //刻度数量
            center: ["50%", "65%"],
            axisLine: {
              lineStyle: {
                width: 20,
                shadowBlur: 0,
                color: [[1, "#0000FF"]],
              },
            },
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            detail: {
              show: false,
            },
          },
          {
            name: "紫",
            type: "gauge",
            radius: "40%",
            startAngle: 180,
            endAngle: 0,
            splitNumber: 0, //刻度数量
            center: ["50%", "65%"],
            axisLine: {
              lineStyle: {
                width: 20,
                shadowBlur: 0,
                color: [[1, "#8B00FF"]],
              },
            },
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            detail: {
              show: false,
            },
          },
        ],
      };
      for (let index = 0; index < parseInt(max - score); index++) {
        options.series.shift();
      }
      return options;
    },
    //获取颜色
    getColorArea(data) {
      let realdata;
      if (data) {
        realdata = JSON.parse(data);
      }
      var max = 0,
        min = 0;
      if (realdata && realdata.color) {
        var result = [];
        realdata.color.forEach((m) => {
          if (m.max > max) {
            max = m.max;
          }
          if (m.min < min) {
            min = m.min;
          }
        });
        realdata.color.forEach((m) => {
          var arr = [];
          var value = ((m.max - min) / (max - min)).toFixed(5);
          let absValue = Math.abs(value);
          // arr.push(m.max);
          arr.push(absValue);
          arr.push(m.color);

          result.push(arr);
        });
        result.sort((a, b) => {
          return a[0] - b[0];
        });
        return result;
      } else {
        return [
          [0.2, "#91c7ae"],
          [0.8, "#63869e"],
          [1, "#c23531"],
        ];
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      //  执行echarts方法
      this.initData();
    });
  },
};
</script>
<style lang="less" scoped>
.examine_name {
  display: inline-block;
  width: 170px;
}
/deep/ .el-textarea__inner {
  padding: 20px;
  font-size: 16px;
  min-height: 100px;
  line-height: 25px;
  color: #000;
  // border: none;
  // margin-top: -10px;
}
.slot_wrap {
  display: flex;
  .save_btn {
    width: 80%;
    text-align: right;
    margin: 20px 0;
  }
  .slot_btn {
    width: 20%;
  }
}
.save_button {
  margin-top: 10px;
  text-align: right;
}
.remove_btn {
  color: #fff;
  font-size: 12px;
  background-color: #091d7c;
  padding: 2px 7px;
  margin-left: 20px;
  border-radius: 5px;
  cursor: pointer;
  display: none;
}
.remove_Warp:hover .remove_btn {
  width: 40px;
  height: 25px;
  line-height: 22px;
  text-align: center;
  font-size: 12px;
  display: inline-block;
}
.tab {
  width: 100%;
  margin: 0 auto;

  tr {
    td {
      border: 1px solid #ebeef5;
      line-height: 30px;
      font-size: 14px;
      color: #606266;
      padding: 5px;
    }
  }
}

// >>> .vxe-table--header {
//   .vxe-header--row:nth-child(2) {
//     display: none;
//   }

//   .vxe-table--body-wrapper .body--wrapper {
//     overflow: hidden;
//   }
// }

// >>> .body--wrapper {
//   overflow: hidden !important;
// }

.title {
  font-size: 14px;
  font-weight: bolder;
}

.content-wrap {
  min-height: 150px;
  border-top: 1px solid #ddd;
}

.content {
  padding: 0 30px;
  font-size: 16px;
  line-height: 30px;
  color: #000;
}

.title {
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  // line-height: 50px;
  margin-bottom: 10px;
  color: #000;
}

.title_warp {
  // display: none;

  .date {
    font-size: 16px;
    text-align: left;
  }

  .hospital {
    font-size: 28px;
    text-align: center;
    color: #000;
  }
}

.text-right {
  font-size: 14px;
  color: #000;
  margin-top: 20px;
  // display: none;
  .autograph {
    display: flex;
    justify-content: space-between;
    .autograph_warp {
      display: flex;
      align-items: center;
    }
  }
}
.Title {
  font-size: 14px;
  font-weight: 600;
  line-height: 40px;
  padding-left: 20px;
  margin-bottom: 20px;
  color: #333;
}

.el-table {
  font-size: 14px;
  text-align: center;
  border: none;
}

/* 遮挡 */
.cover {
  position: absolute;
  right: 0;
  top: 0;
  width: 100px;
  height: 40px;
  background-color: #fff;
}

.ScaleTitle {
  /*width: 800px;*/
  margin: 0 auto;
  border: 1px solid #ddd;
  border-bottom: none;
  text-align: center;
  line-height: 40px;
  font-size: 14px;
  color: #000;
}

.border-top {
  border-top: 1px solid #ddd;
}

.border-left {
  border-left: 1px solid #ddd;
}

.border-right {
  border-right: 1px solid #ddd;
}

.border-bottom {
  border-bottom: 1px solid #ddd;
}

.border-top-bottom {
  border-bottom: 1px solid #ddd;
  border-top: 1px solid #ddd;
}

.tab-warp {
  border: 1px solid #ddd;
  border-top: none;
  margin: 0 auto;
  /*width: 800px;*/
}
.conclusion-list {
  padding: 20px 20px 10px;
  font-size: 16px;
  min-height: 150px;
  line-height: 25px;
  color: #000;
  border: none;
}
.edit-btn {
  text-align: center;
  margin-bottom: 10px;
}
.canvas_warp {
  display: flex;
  flex-wrap: wrap;
  padding: 10px;
  justify-content: space-between;

  div {
    margin: 10px 0;
  }
}

.twoLineBox {
  margin-top: 0px !important;
  margin-left: 30px;
  border-top: 2px solid #333;
  border-bottom: 2px solid #333;
  color: #333;
}
.towLineTitle {
  font-size: 18px;
  font-weight: 500;
  color: "#464646";
  text-align: center;
}
.twoLine {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.twoLine .twoLineItem {
  width: 25%;
  text-align: center;
}
</style>
<style>
#tab td {
  color: #000;
  border-right: 1px solid #ddd;
  border-top: 1px solid #ddd;
}

#tab {
  border-right: none;
  border-bottom: 1px solid #ddd;
  min-height: 100%;
}
@media print {
  .no-print {
    display: none;
  }
  #printreport .title_warp {
    display: block;
  }
  #printreport .title {
    border: none;
    font-size: 25px;
    line-height: 40px;
  }

  #printreport .ScaleTitle {
    font-size: 22px;
    border: 1px solid #000;
    border-bottom: none;
  }

  #printreport .Title {
    font-size: 20px;
    border-bottom: 1px solid #000;
  }

  #printreport .tab-warp {
    border: none;
  }
  #printreport .slot_wrap {
    display: none;
  }
  #printreport .border-top {
    border-top: 1px solid #000;
  }

  #printreport .contents {
    border: 1px solid #000;
    border-top: none;
  }

  #printreport .text-right {
    font-size: 20px;
    display: block;
    margin-top: 20px;
  }

  #printreport .autograph div {
    margin-right: 0px;
    overflow: hidden;
  }
  #printreport .autograph_warp {
    line-height: 80px;
  }

  #printreport .tab td {
    color: #000;
    font-size: 18px;
    border: 1px solid #000;
  }

  #printreport .content {
    font-size: 18px;
    color: #000;
  }

  #printreport .content-wrap {
    min-height: 150px;
    /* border: 1px solid #000; */
  }

  #printreport .border-top {
    /* border-top: 1px solid #000; */
  }

  #printreport .border-left {
    /* border-left: 1px solid #000; */
  }

  #printreport .border-right {
    /* border-right: 1px solid #000; */
  }

  #printreport .border-bottom {
    /* border-bottom: 1px solid #000; */
  }

  #printreport .border-top-bottom {
    /* border-bottom: 1px solid #000; */
    /* border-top: 1px solid #000; */
  }

  #printreport .tab-warp {
    /* border: 1px solid #000; */
    border-top: none;
  }

  #printreport #tab td {
    color: #000;
    /* border-right: 1px solid #000; */
    /* border-top: 1px solid #000; */
  }

  #printreport #tab {
    border-right: none;
    /* border-bottom: 1px solid #000; */
    min-height: 100%;
  }
}
@media print {
  #print .title_warp {
    display: block;
  }
  #print .title {
    border: none;
    font-size: 25px;
    line-height: 40px;
  }
  #print .slot_wrap {
    display: none;
  }
  #print .ScaleTitle {
    font-size: 22px;
    border: 1px solid #000;
    border-bottom: none;
  }

  #print .Title {
    font-size: 20px;
    border-bottom: 1px solid #000;
  }

  #print .tab-warp {
    border: none;
  }

  #print .border-top {
    border-top: 1px solid #000;
  }

  #print .contents {
    border: 1px solid #000;
    border-top: none;
  }

  #print .text-right {
    font-size: 20px;
    display: block;
    margin-top: 20px;
  }

  #print .autograph div {
    margin-right: 0px;
    overflow: hidden;
  }
  #print .autograph_warp {
    line-height: 80px;
  }

  #print .tab td {
    color: #000;
    font-size: 18px;
    border: 1px solid #000;
  }

  #print .content {
    font-size: 18px;
    color: #000;
  }

  #print .content-wrap {
    min-height: 150px;
    /* border: 1px solid #000; */
  }

  #print .border-top {
    /* border-top: 1px solid #000; */
  }

  #print .border-left {
    /* border-left: 1px solid #000; */
  }

  #print .border-right {
    /* border-right: 1px solid #000; */
  }

  #print .border-bottom {
    /* border-bottom: 1px solid #000; */
  }

  #print .border-top-bottom {
    /* border-bottom: 1px solid #000; */
    /* border-top: 1px solid #000; */
  }

  #print .tab-warp {
    /* border: 1px solid #000; */
    border-top: none;
  }

  #print #tab td {
    color: #000;
    /* border-right: 1px solid #000; */
    /* border-top: 1px solid #000; */
  }

  #print #tab {
    border-right: none;
    /* border-bottom: 1px solid #000; */
    min-height: 100%;
  }
}
</style>
<style media="printContent">
@page {
  margin: 20mm;
}
</style>



// WEBPACK FOOTER //
// src/views/hospital/detailReport.vue